module.exports = __webpack_public_path__ + "static/media/VerimatrixLogo.2eacc643.png";